import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { register } from './utils/serviceWorker';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
register({
  onSuccess: () => {
    console.log('[PWA] App is ready for offline use');
  },
  onUpdate: () => {
    console.log('[PWA] New content available, please refresh');
  },
  onOfflineReady: () => {
    console.log('[PWA] App is ready to work offline');
  }
}); 